import React from 'react'
import { RadioButton } from 'primereact/radiobutton'
import { StaticGrid } from 'components/common'
import { isNameSelectable, NAME_TYPE_PRIORITY } from '../../utils/selectionUtils'
import { useKeyboardNavigation } from '../../hooks/useKeyboardNavigation'

const AssociatedNamesPanel = ({
    names,
    selectedName,
    onNameSelect
}) => {
    const hasContact = names !== null
    const hasNames = names && names.length > 0
    const sortedNames = names
        ? [...names].sort((a, b) => (NAME_TYPE_PRIORITY[a.typeId] ?? 99) - (NAME_TYPE_PRIORITY[b.typeId] ?? 99))
        : []

    const handleKeyDown = useKeyboardNavigation({
        data: sortedNames,
        selectedItem: selectedName,
        keyField: 'lineNum',
        onSelect: onNameSelect,
        isSelectable: (name) => isNameSelectable(name, names)
    })

    const nameTypeTemplate = (rowData) => {
        return (
            <span className={`p-tag custom-badge-base custom-badge-yellow-${rowData.typeId || 1}`}>
                {rowData.type}
            </span>
        )
    }

    const radioTemplate = (rowData) => {
        const selectable = isNameSelectable(rowData, names)

        // Don't show radio button for non-selectable names
        if (!selectable) return null

        const isSelected = selectedName?.lineNum === rowData.lineNum

        return (
            <RadioButton
                inputId={`name-${rowData.lineNum}`}
                name="nameSelection"
                value={rowData}
                onChange={() => onNameSelect(rowData)}
                checked={isSelected}
            />
        )
    }

    const ipiTemplate = (rowData) => rowData.ipiNumber || '-'

    const rowClassName = (rowData) => {
        const selectable = isNameSelectable(rowData, names)
        return selectable ? '' : 'disabled-row'
    }

    const handleRowClick = (e) => {
        const rowData = e.data
        if (isNameSelectable(rowData, names)) {
            onNameSelect(rowData)
        }
    }

    const columnDefinitions = [
        { columnType: 'text', title: 'Select', mapsToField: 'lineNum', template: radioTemplate },
        { columnType: 'text', title: 'Name', mapsToField: 'name' },
        { columnType: 'text', title: 'Type', mapsToField: 'type', template: nameTypeTemplate },
        { columnType: 'text', title: 'IPI Number', mapsToField: 'ipiNumber', template: ipiTemplate }
    ]

    return (
        <div className="contact-search-panel">
            <h5 className="contact-search-panel-title mb-2">Associated Names</h5>
            {hasContact ? (
                hasNames ? (
                    <StaticGrid
                        id="associated-names"
                        dataKey="lineNum"
                        data={sortedNames}
                        columnDefinitions={columnDefinitions}
                        showPaginator={false}
                        scrollHeight="auto"
                        emptyMessage="No names found"
                        rowClassName={rowClassName}
                        onRowClick={handleRowClick}
                        onKeyDown={handleKeyDown}
                    />
                ) : (
                    <div className="contact-search-empty-message">
                        No names found for this contact
                    </div>
                )
            ) : (
                <div className="contact-search-empty-message">
                    Select a contact to view names
                </div>
            )}
        </div>
    )
}

export default AssociatedNamesPanel
